import { gql } from '@apollo/client';

export const GET_POESIA_ID = gql`
  {
    getPoesiaId @client
  }
`;

export const GET_POESIA = gql`
  query getPoesia($id: ID!) {
    getPoesia(id: $id) {
      _id
      titulo
      autor
      resumen
      contenido
    }
  }
`;

export const GET_POESIAS = gql`
  query getPoesias($paginate: getPoesiasPaginate!) {
    getPoesias(paginate: $paginate) {
      poesias {
        node {
          _id
          titulo
          autor
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_POESIAS = gql`
  query searchPoesias($paginate: searchPoesiasPaginate!) {
    searchPoesias(paginate: $paginate) {
      poesias {
        node {
          _id
          titulo
          autor
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_POESIA = gql`
  mutation createPoesia($input: CreatePoesiaInput!) {
    createPoesia(input: $input) {
      _id
      titulo
      autor
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const UPDATE_POESIA = gql`
  mutation updatePoesia($input: UpdatePoesiaInput) {
    updatePoesia(input: $input) {
      _id
      titulo
      autor
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const REMOVE_POESIA = gql`
  mutation removePoesia($input: DeletePoesiaInput!) {
    removePoesia(input: $input) {
      code
      success
      message
    }
  }
`;
